const ViewTaskPage = () => {
  return (
    <>
      <div className="single_page">cscbdskb</div>
    </>
  );
};

export default ViewTaskPage;
